export default "__VITE_ASSET__Dbuk7cJQ__"